function log(s) {
  console.info('[react-ga]', s);
}

module.exports = log;
